import { useEffect, useState } from "react";

/** Below md: no sidebar, the tab bar instead (AppShell). */
export const PHONE_WIDTH = "(max-width: 47.99rem)";

/** The sidebar at its full width, names and all: 75rem up. */
export const SIDEBAR_FULL = "(min-width: 75rem)";

/** The sidebar as a rail, md to 75rem: icons with their names hidden. */
export const RAIL = "(min-width: 48rem) and (max-width: 74.99rem)";

/** Whether a media query holds, kept as the window changes. */
export function useMedia(query: string): boolean {
  const [on, setOn] = useState(() => window.matchMedia?.(query).matches ?? false);
  useEffect(() => {
    const mq = window.matchMedia?.(query);
    if (!mq) return;
    const change = () => setOn(mq.matches);
    change();
    mq.addEventListener("change", change);
    return () => mq.removeEventListener("change", change);
  }, [query]);
  return on;
}
